module.exports = __webpack_public_path__ + "media/src/images/icon__sad--1--dark-ffe4a0582fa4f65a5b5c82861ea42f71.png";